import { TargetsDiscovery } from '@sellsy/sse';
import sseHandlers from 'sse/Handlers';
import Env from 'Services/Env';

export default {

    /**
     * @returns TargetsDiscovery discovery
     */
    create : () => {

        let config = Env.get('mercure');

        if(config && Object.keys(config).length > 0){

            let discovery = new TargetsDiscovery(sseHandlers);
            discovery.setup(config);

            return discovery;
        }
    }

};